module.exports = __webpack_public_path__ + "img/btn_can_flag.93e3fb8c.jpg";